import allBalanceOfSelector from './allBalanceOfSelector';
import balanceOfSelectorFamily from './selectorFamily';

export default balanceOfSelectorFamily;

export { allBalanceOfSelector };
